import React from "react";
import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";

import {projectOne, projectTwo, projectThree, projectFour, projectFive, projectSix} from "../../assets";

const Projects = () => {
    const projects = [
        {
            title: "Cypress E2E Automation",
            des: "End-to-end UI test automation for an airline booking platform using Cypress, covering critical flows like search, selection, and booking.",
            src: projectOne,
            githubLink: "https://github.com/cesaragudeloh/vueling-test",
        },
        {
            title: "Serenity/JS and Playwright",
            des: "Web automation framework built with Serenity/JS and Playwright, applying BDD concepts and structured test design to improve readability and reporting.",
            src: projectTwo,
            githubLink: "https://github.com/cesaragudeloh/albedo-serenity-js-test",
        },
        {
            title: "Mobile Test Automation",
            des: "Mobile automation using Appium and Serenity BDD with the Screenplay Pattern, validating key user journeys in the Cinemark APP",
            src: projectThree,
            githubLink:
                "https://github.com/cesaragudeloh/cinemark-app-automation/tree/master/OnlineStore",
        },
        {
            title: "Web Automation",
            des: "Web automation suite using Serenity BDD, Screenplay Pattern, Gherkin, and Cucumber to validate core web flows with readable BDD scenarios on Cinemark website",
            src: projectFour,
            githubLink: "https://github.com/cesaragudeloh/cinemark-web-automation",
        },
        {
            title: "API Automation Framework",
            des: "API automation suite using Serenity BDD, Screenplay Pattern, and Cucumber to validate REST services, business rules, and negative scenarios.",
            src: projectFive,
            githubLink: "https://github.com/cesaragudeloh/TestAppGate/tree/trunk",
        },
        {
            title: "Cypress with BDD",
            des: "End-to-end test automation framework built with Cypress, using Gherkin syntax and Cucumber for behavior-driven development.",
            src: projectSix,
            githubLink: "https://github.com/cesaragudeloh/cypress-blankfactor",
        },


    ];

    return (
        <section
            id="projects"
            className="w-full py-20 border-b-[1px] border-b-black"
        >
            <div className="flex justify-center items-center text-center">
                <Title title="VISIT MY PORTFOLIO" des="Projects"/>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14 mt-10">
                {projects.map((p, idx) => (
                    <ProjectsCard
                        key={idx}
                        title={p.title}
                        des={p.des}
                        src={p.src}
                        githubLink={p.githubLink}
                    />
                ))}
            </div>
        </section>
    );
};

export default Projects;